import { createPopper } from "@popperjs/core";

document.addEventListener("click", function (event) {
  const target =
    event.target.closest("[data-filter-target]") ||
    event.target.closest("[data-feature-filter-target]") ||
    event.target.closest("[data-filter-select]") ||
    event.target.closest("[data-feature-filter-select]");

  if (!target) {
    closeFilters();
  }
});

document.querySelectorAll("[data-filter-target]").forEach((element) => {
  const filterSelect = document.querySelector(
    `#${element.dataset.filterTarget}`,
  );

  if (!filterSelect) {
    console.error(`Couldn't locate ${element.dataset.filterTarget}`);
    return;
  }

  element.addEventListener("click", (event) => {
    closeFiltersExcept(filterSelect);

    filterSelect.classList.toggle("invisible");
    createPopper(element, filterSelect, {
      placement: "bottom",
    });
  });
});

document
  .querySelectorAll("[data-exact-select-value]")
  .forEach((selectElement) => {
    selectElement.addEventListener("click", (event) => {
      selectElement.querySelectorAll(`[data-icon]`).forEach((iconElement) => {
        iconElement.classList.add("hidden");
      });

      const select = selectElement.closest("fieldset").querySelector("select");
      const wasSelected = selectElement.dataset.exactSelectSelected === "true";

      if (wasSelected) {
        selectElement.dataset.exactSelectSelected = "false";

        selectElement
          .querySelector(`[data-icon="unselected"]`)
          .classList.remove("hidden");
        selectElement
          .querySelector(`[data-icon="selected"]`)
          .classList.add("hidden");

        const valueToDeselect = selectElement.dataset.exactSelectValue;

        for (let i = 0; i < select.options.length; i++) {
          if (select.options[i].value === valueToDeselect) {
            select.options[i].selected = false;
          }
        }
      } else {
        if (!select.multiple) {
          for (let i = 0; i < select.options.length; i++) {
            select.options[i].selected = false;
          }

          selectElement
            .closest("fieldset")
            .querySelectorAll("[data-exact-select-selected]")
            .forEach((element) => {
              element
                .querySelector('[data-icon="selected"]')
                .classList.add("hidden");
              element
                .querySelector('[data-icon="unselected"]')
                .classList.remove("hidden");
            });
        }

        selectElement.dataset.exactSelectSelected = "true";

        selectElement
          .querySelector(`[data-icon="selected"]`)
          .classList.remove("hidden");
        selectElement
          .querySelector(`[data-icon="unselected"]`)
          .classList.add("hidden");

        const valueToSelect = selectElement.dataset.exactSelectValue;

        for (let i = 0; i < select.options.length; i++) {
          if (select.options[i].value === valueToSelect) {
            select.options[i].selected = true;
          }
        }
      }

      const selectedElements = Array.from(
        selectElement.parentNode.querySelectorAll(
          "[data-exact-select-selected]",
        ),
      ).filter((element) => element.dataset.exactSelectSelected === "true");
      const buttonPillElement = selectElement
        .closest("[data-filter-select]")
        .parentNode.querySelector("[data-filter-target]");

      if (selectedElements.length > 0) {
        buttonPillElement.classList.add("filter-active");
        buttonPillElement.classList.remove("filter-inactive");
      } else {
        buttonPillElement.classList.remove("filter-active");
        buttonPillElement.classList.add("filter-inactive");
      }
    });
  });

const closeFiltersExcept = (filterSelect) => {
  document.querySelector("#multi-click-explainer").classList.add("hidden");
  document
    .querySelectorAll(`[data-filter-select]:not(#${filterSelect.id})`)
    .forEach((element) => {
      element.classList.add("invisible");
    });
};

const closeFilters = () => {
  document.querySelector("#multi-click-explainer").classList.add("hidden");
  document.querySelectorAll("[data-filter-select]").forEach((element) => {
    element.classList.add("invisible");
  });
};
